import React, { useRef, useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { Editor } from '@tinymce/tinymce-react';
import { Controller, Control } from 'react-hook-form';

interface TinyMceEditorProps {
  name: string;
  control: Control<any>;
  label?: string;
  defaultValue?: string;
  height?: number;
}

const TinyMceEditor: React.FC<TinyMceEditorProps> = ({
  name,
  control,
  label,
  defaultValue = '',
  height = 600,
}) => {
  const editorRef = useRef<any>(null);
  const [isEditorReady, setIsEditorReady] = useState(false);
  const isMountedRef = useRef(true);

  // Cleanup ao desmontar
  useEffect(() => {
    isMountedRef.current = true;
    
    return () => {
      isMountedRef.current = false;
      
      // Remove o editor de forma segura quando o componente for desmontado
      if (editorRef.current) {
        try {
          // Verifica se o editor ainda existe no DOM antes de remover
          if (editorRef.current.getElement && typeof editorRef.current.getElement === 'function') {
            const element = editorRef.current.getElement();
            if (element && document.body.contains(element)) {
              editorRef.current.remove();
            }
          }
        } catch (error) {
          // Ignora erros de remoção quando o DOM já foi limpo
          // Não loga para evitar poluir o console
        } finally {
          editorRef.current = null;
          setIsEditorReady(false);
        }
      }
    };
  }, []);
  

  return (
    <Box>
      {label && <Typography variant="subtitle1" sx={{ mb: 1 }}>{label}</Typography>}
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <Editor
            tinymceScriptSrc='/tinymce/tinymce.min.js'
            onInit={(_evt, editor) => {
              editorRef.current = editor;
              setIsEditorReady(true);
            }}
            value={field.value}
            onEditorChange={(content) => {
              field.onChange(content);
            }}
            init={{
                height: height,
                menubar: false,
                promotion: false,
                license_key: 'gpl',
                plugins: [
                  'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
                  'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                  'insertdatetime', 'media', 'table', 'preview', 'help', 'wordcount'
                ],
                toolbar: 'undo redo code | blocks | ' +
                  'bold italic forecolor | alignleft aligncenter ' +
                  'alignright alignjustify | bullist numlist outdent indent | ' +
                  'removeformat',
                content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
            }}
          />
         
        )}
      />
    </Box>
  );
};

export { TinyMceEditor };
